'use client';

import { c as _c } from "react/compiler-runtime";
import Markdown from 'markdown-to-jsx';
import type { ComponentPropsWithoutRef } from 'react';

// 스트리밍 중 markdown-to-jsx가 매 글자 재파싱하며 같은 줄을 제목↔본문으로 재분류해도
// 글씨 크기가 튀지 않도록, 모든 블록 텍스트를 본문 크기로 고정하고 위계는 굵기·색·여백으로 준다.
const BODY_TYPO = 'typo-body3 mobile-tablet:typo-body4';
const ScrollableTable = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <div className="my-8 overflow-x-auto"><table {...props} className={`${BODY_TYPO} w-full border-collapse border border-Gray-200`}>{children}</table></div>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
const MARKDOWN_OPTIONS = {
  forceWrapper: true,
  wrapper: 'div' as const,
  overrides: {
    a: {
      props: {
        className: 'underline break-all text-B-600',
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    },
    p: {
      props: {
        className: 'whitespace-pre-wrap my-4 first:mt-0 last:mb-0'
      }
    },
    strong: {
      props: {
        className: 'font-700 text-Gray-900'
      }
    },
    em: {
      props: {
        className: 'italic text-Gray-700'
      }
    },
    hr: {
      props: {
        className: 'my-12 border-0 border-t border-Gray-200'
      }
    },
    h1: {
      props: {
        className: `${BODY_TYPO} font-700 text-Gray-900 mt-16 mb-6 first:mt-0`
      }
    },
    h2: {
      props: {
        className: `${BODY_TYPO} font-700 text-Gray-900 mt-16 mb-6 first:mt-0`
      }
    },
    h3: {
      props: {
        className: `${BODY_TYPO} font-600 text-Gray-900 mt-12 mb-4 first:mt-0`
      }
    },
    h4: {
      props: {
        className: `${BODY_TYPO} font-600 text-Gray-700 mt-12 mb-4 first:mt-0`
      }
    },
    ul: {
      props: {
        className: 'list-disc pl-20 my-8 marker:text-Gray-400'
      }
    },
    ol: {
      props: {
        className: 'list-decimal pl-20 my-8 marker:text-Gray-400'
      }
    },
    li: {
      props: {
        className: 'my-2',
        style: {
          listStyleType: 'inherit'
        }
      }
    },
    code: {
      props: {
        className: `${BODY_TYPO} bg-Gray-100 px-4 py-[1px] rounded-xxsmall font-mono`
      }
    },
    pre: {
      props: {
        className: `${BODY_TYPO} bg-Gray-100 p-12 rounded-small overflow-x-auto my-8 font-mono`
      }
    },
    blockquote: {
      props: {
        className: `${BODY_TYPO} my-8 px-16 py-12 bg-B-25 rounded-medium text-Gray-700`
      }
    },
    table: {
      component: ScrollableTable
    },
    td: {
      props: {
        className: `${BODY_TYPO} border border-Gray-200 px-12 py-4 text-left`
      }
    },
    th: {
      props: {
        className: `${BODY_TYPO} bg-Gray-100 border border-Gray-200 px-12 py-4 text-left font-600`
      }
    }
  }
};
interface MarkdownContentProps {
  children: string;
  className?: string;
}
export const MarkdownContent = t0 => {
  const $ = _c(3);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className) {
    t1 = <Markdown className={className} options={MARKDOWN_OPTIONS}>{children}</Markdown>;
    $[0] = children;
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};